<template>
  <div class="document-condition">
    <div class="document-condition__wrapper">
      <c-input-2
        v-model="condition.citizenships"
        class="document-condition__citizenship"
        floating-label="Гражданство"
        type="select"
        :multiple="true"
        :items="citizenshipsDictionary"
        :checkbox="true"
        :checkbox-value="condition.citizenshipsExcept"
        :checkbox-type="'icon'"
        :checkbox-tooltip="{
          disabledText: 'Фильтр по всем значениям в справочнике, кроме выбранных',
          activeText: 'Выключить фильтр по всем значениям в справочнике, кроме выбранных',
          notActiveText: 'Включить фильтр по всем значениям в справочнике, кроме выбранных',
        }"
        :searchable="true"
        @checkboxChange="onExceptChange"
      />
      <c-input-2
        v-model="condition.positions"
        class="document-condition__position"
        floating-label="Должность"
        type="select"
        :multiple="true"
        :items="positionsDictionary"
        :searchable="true"
      />
      <c-button-2
        v-b-tooltip
        class="document-condition__remove hidden-sm"
        size="iconic"
        title="Удалить"
        :icon="{ icon: 'trash', color: 'secondary' }"
        @click="$emit('remove')"
      />
      <c-button-2
        class="document-condition__remove hidden-md"
        size="small"
        label="Удалить"
        :icon="{
          icon: 'trash',
          color: 'secondary',
        }"
        @click="$emit('remove')"
      />
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";

import Input2 from "@/components/controls2/Input";
import Button2 from "@/components/controls2/Button";

export default {
  components: {
    "c-input-2": Input2,
    "c-button-2": Button2,
  },
  props: ["condition"],

  computed: {
    ...mapState("documentForm", ["citizenshipsDictionary", "positionsDictionary"]),
  },

  created() {
    this.$store.dispatch("documentForm/loadCitizenships");
    this.$store.dispatch("documentForm/loadPositions");
  },

  methods: {
    onExceptChange(value) {
      this.condition.citizenshipsExcept = value;
    },
  },
};
</script>

<style lang="scss">
@import "~@/assets/styles/vars";

.document-condition {
  &__wrapper {
    display: flex;
  }
  &__remove {
    flex-shrink: 0;
    margin-top: 22px;
    @include onlyExtraSmall {
      width: fit-content;
      margin-top: 0;
      margin-left: auto;
    }
  }
  &__citizenship {
    width: 366px;
    flex-shrink: 0;
    margin-right: 30px;

    @include mobileAndTablet {
      width: 216px;
    }
  }
  &__position {
    flex-grow: 1;
    margin-right: 30px;
  }

  @include onlyExtraSmall {
    &__wrapper {
      flex-direction: column;
    }
    &__citizenship,
    &__position {
      width: auto;
      margin-right: 0;
      margin-bottom: 25px;
    }
  }
}
.hidden-sm {
  @include onlyExtraSmall {
    display: none !important;
  }
}
.hidden-md {
  @media (min-width: 450px) {
    display: none !important;
  }
}
</style>
